import Andrew from './images/Dr Andrew.jpg'
import Michelle from './images/Dr Michelle.jpg'
import Steve from './images/Dr Steve.jpg'

const Doctors = [
    {
        name: "Dr Andrew",
        profession: "Pathologist",
        image: Andrew
    },
    {
        name: "Dr Michelle",
        profession: "Microbiologist",
        image: Michelle
    },
    {
        name: "Dr Steve",
        profession: "Biochemist",
        image: Steve
    },

]

export default Doctors;